export const properties = [];
